{
  "commonHeader": {
    "upgradeToPro": "Esegui l'upgrade",
    "learnMore": "Scopri di più",
    "AIProductivitySuite": {
      "title": "Suite per la produttività con IA",
      "desc": "Trasforma discussioni stimolanti in risultati straordinari."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Gestisci l’account dell’organizzazione con l’IA",
        "description": "Ottieni risposte intelligenti alle domande sull’account e aiuto per orientarti tra le impostazioni.",
        "terms": "Utilizzando le funzionalità beta di Zoom, accetti {0}",
        "termsText": "i Termini del programma beta di Zoom"
      },
      "diveDeeper": "Approfondisci",
      "shareFeedback": "Condividi feedback in {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Fai una domanda sull’account della tua organizzazione",
      "heroInvite": "Come invito un nuovo utente al mio account?",
      "heroGroups": "Come assegno gli utenti ai gruppi?",
      "heroRoles": "Come gestisco ruoli e autorizzazioni?"
    },
    "backMainAccount": "Torna all’account principale",
    "discoverProducts": "Scopri i prodotti",
    "pricing": "Prezzi",
    "more": "Altro",
    "sidebarExpanded": "espanso",
    "sidebarCollapsed": "compresso",
    "search": "Cerca",
    "users": "Utenti",
    "settings": "Impostazioni dell'account",
    "navigation": "Navigazione",
    "clear": "Cancella",
    "searchPlaceholderAll": "Cerca utenti, impostazioni account o navigazione",
    "searchPlaceholderUsers": "Cerca utenti o navigazione",
    "searchPlaceholderSettings": "Cerca impostazioni account o navigazione",
    "searchPlaceholderNav": "Cerca nella navigazione",
    "searchGuide": "Digita parole chiave per iniziare la ricerca",
    "installOnDesktop": "Installa sul desktop",
    "downloadCenter": "Centro download",
    "getInTouch": "Contattaci",
    "featuredProduct": "prodotto in evidenza",
    "logo": {
      "adminCenter": "Centro amministrazione",
      "subAccount": "Gestione sottoaccount",
      "externalAccount": "Gestione account delegato"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Scopri di più",
      "gotIt": "Ok"
    },
    "coachMark": {
      "dvsTipsTitle": "Le divisioni sono ora disponibili",
      "dvsTipsContent": "Le divisioni servono a creare più istanze di determinati prodotti Zoom nel tuo account."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Scopri di più",
      "gotIt": "Ok"
    },
    "coachMark": {
      "extAccountTipsTitle": "Gestisci gli account esterni",
      "extAccountTipsContent": "Devi gestire un altro account? Invia una richiesta: una volta approvata, sei dentro!"
    }
  },
  "feedback": {
    "dialogTitle": "Fornisci feedback",
    "itemLableForProductArea": "Area prodotti",
    "itemLableForSatisfied": "Quanto sei soddisfatto della tua esperienza?",
    "dissatisfied": "Molto insoddisfatto",
    "satisfied": "Molto soddisfatto",
    "itemLableForFeedback": "Feedback",
    "placeholder": "Grazie per le tue idee, i tuoi commenti e suggerimenti.",
    "btnCancel": "Annulla",
    "btnSubmit": "Invia",
    "supportTips": "Per assistenza tecnica, visita",
    "btnSupport": "Supporto.",
    "messages": {
      "success": "Grazie per il feedback!",
      "productFailed": "L’area prodotti è obbligatoria.",
      "scoreFailed": "Il punteggio di soddisfazione è obbligatorio."
    },
    "products": {
      "General": "Generale",
      "AI": "IA",
      "Apps": "App",
      "Calendar": "Calendario",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Mail",
      "Meetings": "Riunioni",
      "Notes": "Note",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Pianificatore",
      "Tasks": "Attività",
      "TeamChat": "Team Chat",
      "WebinarsAndEvents": "Webinar ed eventi",
      "Whiteboard": "Lavagna",
      "WorkflowAutomations": "Automazioni del flusso di lavoro",
      "WorkspaceReservation": "Prenotazione spazi di lavoro",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Questa esclusione di responsabilità è stata generata dall’amministratore del tuo account.",
    "cancel": "Annulla",
    "agree": "Accetto"
  },
  "shared": {
    "sideMenu": {
      "personal": "Personale",
      "admin": "Amministratore",
      "menu": "Menu",
      "pinned": "Aggiunto ai preferiti",
      "pin": "Aggiungi ai preferiti",
      "unpin": "Rimuovi dai preferiti",
      "moveItem": "Sposta elemento",
      "myAccount": "Il mio account",
      "upgradeToPro": "Passa a Pro",
      "grabbedKeyboard": "{0} preso. Usa le frecce su e giù per spostare, spazio o Invio per rilasciare.",
      "dropped": "{0} rilasciato.",
      "releasedUnchanged": "{0} rilasciato, posizione invariata.",
      "movedToPosition": "{0} spostato in posizione {1} di {2}.",
      "movedUp": "{0} spostato in alto, posizione {1} di {2}.",
      "movedDown": "{0} spostato in basso, posizione {1} di {2}.",
      "movedUpNew": "{0} spostato in alto, nuova posizione {1} di {2}",
      "movedDownNew": "{0} spostato in basso, nuova posizione {1} di {2}",
      "cannotMoveFurther": "{0} non può essere spostato ulteriormente.",
      "grabbedMouse": "{0} preso. Sposta il mouse per riposizionare, fai clic per rilasciare, premi Esc per annullare."
    },
    "item": "Elemento",
    "gotIt": "Ho capito",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Numero telefonico aggiunto correttamente. Ora puoi usarlo per gli accessi futuri e il recupero dell’account.",
    "mfa_to_signin_phone_success": "{phone} è ora il numero di accesso per {email}.",
    "login_passkey_bound_success": "La passkey è stata creata correttamente"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Le seguenti funzioni di gestione avanzata saranno applicate solo a utenti di collaborazione e concessi in licenza",
      "licensed_basic": "Le seguenti funzioni di gestione avanzata saranno applicate solo a utenti base e concessi in licenza",
      "licensed": "Le seguenti funzioni di gestione avanzata saranno applicate solo a utenti concessi in licenza"
    },
    "support": "- Supportato nelle impostazioni dell’account e nelle impostazioni del gruppo di utenti",
    "archive_product": {
      "title": "Archivia riunioni e webinar",
      "detail": "- Le riunioni saranno archiviate quando gli utenti nel tuo account partecipano. Per utilizzare questa impostazione, installa un’<a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">app di archiviazione</a> da Zoom App Marketplace."
    },
    "restrict": {
      "title": "Limita l’uso delle funzioni da parte degli utenti quando partecipano a una riunione",
      "detail": "- Impossibile utilizzare le funzioni selezionate anche se gli organizzatori delle riunioni le abilitano per le riunioni."
    },
    "meeting_integration": {
      "title": "Abilita l’integrazione DLP (Data Loss Prevention) della chat nella riunione",
      "detail": "- Quando è attivato, DLP si applicherà ai messaggi di chat sia pubbliche che private inviati da un partecipante. I messaggi verranno eliminati immediatamente se i partecipanti a una riunione (interna/esterna) stanno chattando e un messaggio viola le policy sulla conformità dell’organizzazione dell’organizzatore."
    },
    "chat_tool": {
      "title": "Strumento Chat Etiquette",
      "detail": "- Identifica parole chiave e modelli di testo definiti in contenuti condivisi e impedisci agli utenti di condividere messaggi indesiderati"
    },
    "information_barriers": {
      "title": "Barriere informative",
      "detail": "- Le barriere informative controllano le comunicazioni tra determinati utenti a scopo di conformità. È possibile imporre limitazioni su riunioni e chat tra utenti di due gruppi e su determinati utenti per impedire a tali utenti di utilizzare specifiche funzioni (ossia chat nella riunione, condivisione schermo e trasferimento dei file). Tali limitazioni impediscono lo scambio di informazioni riservate tra utenti non autorizzati."
    },
    "dashboard": {
      "title": "Dashboard",
      "detail": "- Per il dashboard riunioni > riunioni passate, vengono visualizzati solo i dati di 3 mesi per alcuni utenti"
    },
    "reports": {
      "title": "Report",
      "detail": "- In alcuni report dell’utente sono visualizzati i dati solo per 3 mesi: report su esclusione di responsabilità, report sui registri degli spettatori, report sui registri delle attività dell’amministratore e report di accesso/disconnessione"
    },
    "close": "Chiudi"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Il tuo {planName} verrà annullato il {cancelDate}. Prima di quella data, puoi riattivare le tue licenze dei webinar. Dal {supportStartDate} al {supportEndDate}, puoi contattare l’Assistenza clienti per ottenere i dati dei webinar esistenti. Dopo {dataLossDate}, perderai tutti i dati dei webinar.",
            "nonAdmin": "Il tuo {planName} verrà annullato il {cancelDate}. Entro la data indicata, puoi contattare l’admin del tuo account per riattivare le licenze dei webinar. Dal {supportStartDate} al {supportEndDate}, puoi contattare l’Assistenza clienti per ottenere i dati dei webinar esistenti. Dopo il {dataLossDate}, perderai tutti i dati dei webinar del tuo account."
          },
          "admin": "Il tuo {planName} verrà annullato il {cancelDate}. Entro tale data, puoi riattivare le licenze dei webinar. Dal {supportStartDate} al {supportEndDate}, puoi contattare l’Assistenza clienti per ottenere i {supportContent} dei webinar esistenti. Dopo {dataLossDate}, perderai tutti i dati dei webinar del tuo account.",
          "nonAdmin": "Il tuo {planName} verrà annullato il {cancelDate}. Entro questa data, puoi contattare l’admin del tuo account per riattivare le licenze dei webinar. Dal {supportStartDate} al {supportEndDate}, puoi contattare l’Assistenza clienti per ottenere i {supportContent} dei webinar esistenti. Dopo {dataLossDate}, perderai tutti i dati dei webinar del tuo account."
        },
        "expired": {
          "admin": "Il tuo {planName} è stato annullato. Dal {supportStartDate} al {supportEndDate}, contatta l’assistenza clienti per ottenere i {supportContent} dei webinar esistenti oppure acquista di nuovo Zoom Webinars per ripristinare l’accesso ai dati. Dopo il {dataLossDate}, perderai tutti i dati dei webinar del tuo account.",
          "nonAdmin": "Il tuo {planName} è stato annullato. Dal {supportStartDate} al {supportEndDate}, puoi contattare l’assistenza clienti per ottenere i {supportContent} dei webinar esistenti, oppure contatta l’admin dell’account per acquistare nuovamente Zoom Webinars e ripristinare l’accesso ai dati. Dopo il {dataLossDate}, perderai tutti i dati dei webinar del tuo account."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Il tuo {planName} verrà messo in pausa il {pausedDate} per {pauseDuration}. Durante il periodo di pausa, potrai visualizzare solo i webinar esistenti e le loro risorse. Puoi rimuovere la pausa e riprendere l’abbonamento alle tue licenze dei webinar in qualsiasi momento.",
            "nonAdmin": "Il tuo {planName} verrà messo in pausa il {pausedDate} per {pauseDuration}. Durante il periodo di pausa, potrai visualizzare solo i webinar esistenti e le loro risorse. Puoi contattare l’admin del tuo account per annullare la pausa e riprendere l’abbonamento alle licenze dei webinar in qualsiasi momento."
          },
          "admin": "Il tuo {planName} verrà messo in pausa il {pausedDate} per {pauseDuration}. Durante il periodo di pausa, puoi vedere solo {supportContent}. Puoi rimuovere la pausa e riprendere l’abbonamento alle tue licenze webinar in qualsiasi momento.",
          "nonAdmin": "Il tuo {planName} verrà messo in pausa il {pausedDate} per {pauseDuration}. Durante il periodo di pausa, potrai vedere solo {supportContent}. Puoi contattare l’admin del tuo account per annullare la pausa e riprendere l’abbonamento alle licenze dei webinar in qualsiasi momento."
        },
        "active": {
          "webinars": {
            "admin": "Il tuo {planName} è in pausa per {pauseDuration} a partire dal {pausedDate}. Durante la pausa, puoi visualizzare solo i webinar esistenti. Puoi riattivare l’abbonamento alle licenze dei webinar in qualsiasi momento.",
            "nonAdmin": "Il tuo {planName} è in pausa per {pauseDuration} a partire dal {pausedDate}. Durante la pausa, puoi visualizzare solo i webinar esistenti. Non esitare a contattare l’admin dell’account per riattivare l’abbonamento alle licenze dei webinar in qualsiasi momento."
          },
          "admin": "Il tuo {planName} è in pausa per {pauseDuration}. Durante la pausa, puoi visualizzare solo i {supportContent} dei webinar esistenti. Puoi riattivare l’abbonamento alle licenze dei webinar in qualsiasi momento.",
          "nonAdmin": "Il tuo {planName} è in pausa per {pauseDuration}. Durante la pausa, puoi visualizzare solo i {supportContent} dei webinar esistenti. Non esitare a contattare l’admin dell’account per riattivare l’abbonamento alle licenze dei webinar in qualsiasi momento."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "La tua licenza {planName} verrà messa in pausa il giorno {pausedDate} per {pauseDuration}. Per continuare a organizzare webinar, assegna una licenza attiva a questo utente prima che la sospensione diventi effettiva. Puoi anche rimuovere la pausa per continuare a usare questa licenza.",
            "nonAdmin": "La tua licenza {planName} verrà messa in pausa il giorno {pausedDate} per {pauseDuration}. Durante il periodo di pausa, potrai visualizzare solo i webinar esistenti e le loro risorse. Per continuare a ospitare webinar, contatta l’admin del tuo account affinché assegni una licenza attiva al tuo account prima che la pausa diventi effettiva."
          },
          "active": {
            "admin": "La tua licenza {planName} è in pausa per {pauseDuration} a partire dal giorno {pausedDate}. Durante la pausa, potrai visualizzare solo i webinar esistenti. Puoi riattivare l’abbonamento alla licenza o assegnare una licenza attiva al tuo account per continuare a organizzare webinar.",
            "nonAdmin": "La tua licenza {planName} è in pausa per {pauseDuration} a partire dal giorno {pausedDate}. Durante la pausa, puoi visualizzare solo i webinar esistenti. Per organizzare webinar durante la pausa, contatta l’admin del tuo account per assegnare una licenza attiva al tuo account."
          }
        },
        "cancel": {
          "active": {
            "admin": "La tua licenza {planName} verrà annullata il {cancelDate}. Per continuare a ospitare webinar, riattiva la licenza webinar o assegna una licenza attiva prima che l’annullamento abbia effetto. Se non viene intrapresa alcuna azione, avrai un periodo di grazia dal {supportStartDate} al {supportEndDate} per contattare l’Assistenza clienti e recuperare i dati dei webinar esistenti. Dopo il {dataLossDate}, tutti i dati dei webinar associati al tuo account verranno eliminati in modo permanente.",
            "nonAdmin": "La tua licenza {planName} verrà annullata il {cancelDate}. Per continuare a ospitare webinar, contatta l’admin del tuo account per riattivare la licenza webinar o assegnare una licenza attiva prima che l’annullamento abbia effetto. Se non viene intrapresa alcuna azione, avrai un periodo di grazia dal {supportStartDate} al {supportEndDate} per contattare l’Assistenza clienti e recuperare i dati dei webinar esistenti. Dopo il {dataLossDate}, tutti i dati dei webinar associati al tuo account verranno eliminati in modo permanente."
          },
          "expired": {
            "admin": "La tua licenza {planName} è stata annullata. Per continuare a organizzare webinar, assegna una licenza attiva a questo utente. Dal giorno {supportStartDate} al giorno {supportEndDate}, puoi contattare l’Assistenza clienti per recuperare i dati dei webinar esistenti.",
            "nonAdmin": "La tua licenza {planName} è stata annullata. Per continuare a organizzare webinar, contatta l’admin del tuo account affinché assegni una licenza attiva al tuo profilo. Dal giorno {supportStartDate} al giorno {supportEndDate}, contatta l’Assistenza clienti per recuperare i dati dei webinar esistenti."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "La tua licenza {planName} verrà messa in pausa il giorno {pausedDate} per {pauseDuration}. Durante il periodo di pausa, potrai visualizzare solo le {supportContent} dei webinar precedenti. Per continuare ad accedere alle risorse dei webinar, assegna una licenza attiva a questo utente prima che la pausa diventi effettiva. Puoi anche rimuovere la pausa per continuare a usare questa licenza.",
              "nonAdmin": "La tua licenza {planName} verrà messa in pausa il giorno {pausedDate} per {pauseDuration}. Durante il periodo di pausa, potrai visualizzare solo le {supportContent}. Per continuare ad accedere alle risorse dei webinar, contatta l’admin del tuo account affinché assegni una licenza attiva al tuo profilo."
            },
            "active": {
              "admin": "Il tuo piano {planName} è in pausa per {pauseDuration} a partire dal giorno {pausedDate}. Durante la pausa, potrai visualizzare solo le {supportContent} dei webinar esistenti. Per continuare ad accedere alle risorse dei webinar, assegna una licenza attiva al tuo account. Puoi anche riattivare l’abbonamento a questa licenza in qualsiasi momento.",
              "nonAdmin": "Il tuo piano {planName} è in pausa per {pauseDuration} a partire dal giorno {pausedDate}. Durante la pausa, potrai visualizzare solo le {supportContent} dei webinar esistenti. Per organizzare webinar durante la pausa, contatta l’admin del tuo account affinché assegni una licenza attiva al tuo account."
            }
          },
          "cancel": {
            "active": {
              "admin": "Il tuo {planName} verrà annullato il giorno {cancelDate}. Per continuare a organizzare webinar, assegna una licenza attiva al tuo account prima che l’annullamento abbia effetto. Puoi riattivare questa licenza prima del giorno {cancelDate}. Dal giorno {supportStartDate} al giorno {supportEndDate}, puoi contattare l’Assistenza clienti per recuperare i {supportContent} dei webinar esistenti.",
              "nonAdmin": "La tua licenza {planName} verrà annullata il {cancelDate}. Per continuare a ospitare webinar, contatta l’admin del tuo account per riattivare la licenza webinar o assegnare una licenza attiva prima che l’annullamento abbia effetto. Se non viene intrapresa alcuna azione, avrai un periodo di grazia dal {supportStartDate} al {supportEndDate} per contattare l’Assistenza clienti e recuperare i {supportContent} dei webinar esistenti. Dopo il {dataLossDate}, tutti i dati dei webinar associati al tuo account verranno eliminati in modo permanente."
            },
            "expired": {
              "admin": "La tua licenza {planName} è stata annullata. Per continuare a organizzare webinar, assegna una licenza attiva a questo utente. Dal giorno {supportStartDate} al giorno {supportEndDate}, contatta l’Assistenza clienti per recuperare {supportContent} dei webinar esistenti.",
              "nonAdmin": "La tua licenza {planName} è stata annullata. Per continuare a organizzare webinar, contatta l’admin del tuo account affinché assegni una licenza attiva al tuo profilo. Dal giorno {supportStartDate} al giorno {supportEndDate}, contatta l’Assistenza clienti per recuperare {supportContent} dei webinar esistenti."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "dati",
        "recordingsAndTranscripts": "registrazioni e trascrizioni",
        "reports": "report",
        "summaries": "riepiloghi",
        "dashboard": "dashboard"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "registrazioni e trascrizioni dei webinar precedenti",
          "reports": "report dei webinar precedenti",
          "summaries": "riassunti dei webinar precedenti",
          "dashboard": "dashboard dei webinar precedenti",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Riattiva il piano",
    "purchasePlan": "Acquista piano",
    "removePause": "Interrompi pausa",
    "resumeSubscription": "Riattiva l’abbonamento",
    "month": "mese",
    "months": "mesi",
    "assignLicense": "Assegna licenza"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Ok"
    },
    "coachMark": {
      "tipsTitle": "La rubrica diventerà Directory clienti",
      "tipsContent": "Nella versione di ottobre 2026 rinomineremo Rubrica in Directory clienti per riflettere meglio il suo scopo. Tutte le funzionalità, le autorizzazioni e i flussi di lavoro esistenti resteranno invariati: continuerai a gestire gli elenchi clienti (rubriche) e i contatti come fai oggi."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Stiamo aggiornando i nostri termini e le nostre politiche",
    "agreeSub": "Continuando a utilizzare Zoom accetti i <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Termini di servizio</a> e la <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Politica sulla privacy</a> aggiornati.",
    "continue": "Continua"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Torna all’account principale",
      "backLinkedAccount": "Torna all’account collegato",
      "backMyAccount": "Torna a Il mio account",
      "myAccount": "Il mio account"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion è ora disponibile per il tuo account",
      "desc": "Ecco alcune delle funzionalità di Custom AI Companion che puoi usare nel tuo account:",
      "studioTitle": "AI Studio",
      "studioDesc": "Personalizza l’esperienza di AI Companion per la tua organizzazione.",
      "integrationsTitle": "Integrazioni di terze parti",
      "integrationsDesc": "Sfrutta le app di terze parti per semplificare i flussi di lavoro.",
      "clipsTitle": "Avatar personalizzati per Zoom Clips",
      "clipsDesc": "Consenti agli utenti di personalizzare gli avatar IA da usare nei loro clip."
    },
    "coachMark": {
      "licenseTitle": "Hai {0} licenze Custom AI Companion da assegnare",
      "licenseDesc": "Assegna queste licenze in <b>Gestione utenti</b> in modo che gli utenti possano iniziare a usare le funzionalità avanzate di AI Companion.",
      "settingTitle": "Consulta le impostazioni Custom AI Companion del tuo account",
      "settingDesc": "Configura le impostazioni di ciascuna funzionalità Custom AI in <b>Impostazioni account</b>. <a href=\"/account/setting?tab=aicompanion\">Vai alle impostazioni</a>",
      "groupSettingTitle": "Consulta le impostazioni Custom AI del tuo gruppo",
      "groupSettingDesc": "Configura le impostazioni di ciascuna funzionalità Custom AI in <b>Impostazioni gruppo</b>. <a href=\"/account/group\">Vai alle impostazioni</a>"
    },
    "common": {
      "learnMore": "Scopri di più",
      "quickTour": "Fai un tour rapido",
      "remindLater": "Ricordamelo più tardi",
      "dismiss": "Chiudi",
      "next": "Avanti",
      "back": "Indietro",
      "gotIt": "Ok",
      "goToSetting": "Vai alle impostazioni"
    },
    "aiPanelToast": "Attiva l’impostazione <b>Pannello IA in Zoom Workplace</b> per iniziare a usare tutte le funzionalità di Custom AI Companion."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Ok",
      "next": "Avanti",
      "remindMeLater": "Ricordamelo più tardi",
      "waffleMenuTitle": "Benvenuto nella nuova esperienza web di Zoom",
      "waffleMenuDesc": "Accedi ai prodotti Zoom da ovunque ti trovi con il nuovo <b>menu prodotti.</b>",
      "profileMenuTitle": "Il mio account",
      "profileMenuDesc": "Trova il tuo profilo e le impostazioni personali in <b>Il mio account.</b>",
      "personalTitle": "Accedi a tutto ciò di cui hai bisogno",
      "personalDesc": "<b>Il mio account</b> include il tuo profilo, le impostazioni, le trascrizioni delle riunioni e altro ancora.",
      "adminCenterTitle": "Trova le impostazioni dell’organizzazione nel Centro amministrazione",
      "adminCenterDesc": "Il nuovo <b>Centro amministrazione</b> ti consente di configurare i prodotti e regolare le impostazioni per l’intera organizzazione.",
      "adminMenuForTitle": "Usa il Centro amministrazione come un professionista",
      "adminMenuForAccountSettings": "<b>Impostazioni</b> ti consente di accedere alle impostazioni predefinite dei prodotti per tutti i membri dell’organizzazione.",
      "adminMenuForContentManagementItem": "In <b>Gestione dei contenuti</b> puoi gestire tutti i contenuti generati dagli utenti.",
      "adminMenuForConfigureProductsItem": "<b>Configurazione prodotti</b> ti consente di impostare i prodotti e completare le attività di amministrazione.",
      "adminMenuForNoItems": "Il nuovo centro amministrazione ti consente di accedere e gestire più facilmente le impostazioni dell’account e i prodotti. Puoi anche fissare gli elementi che vuoi per un accesso più rapido.",
      "tryNewExperience": "Prova la nuova esperienza",
      "tryNewExperienceDetail": "Provala! Potrai sempre tornare a questa esperienza classica.",
      "tryNewExperienceTitle": "Nuovo aspetto per Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Tutti i diritti riservati.",
    "terms": "Termini",
    "privacy": "Privacy",
    "trust_center": "Trust Center",
    "acceptable_use_guidelines": "Linee guida per l’uso accettabile",
    "legal": "Note legali",
    "do_not_sell_my_personal_information": "Le tue scelte sulla privacy",
    "cookie_preferences": "Preferenze cookie",
    "pricing": "Piani e prezzi",
    "feedback": "Feedback",
    "contact_us": "Contattaci"
  },
  "termChange": {
    "changeTerm": {
      "title": "Accordo di modifica del periodo di rinnovo",
      "quoteNumbers": "Modulo/i d’ordine modificato/i - {0}",
      "content1": "Accettando questi termini, il Cliente accetta di modificare il periodo di rinnovo dell’abbonamento esistente per tutti i moduli d’ordine tra Zoom Communications, Inc. (“Zoom”) e il Cliente, cambiando il periodo impegnato da un rinnovo mensile a un {0}. In cambio di questo impegno, Zoom accetta di mantenere i prezzi attuali del Cliente per la durata del primo nuovo periodo di rinnovo.",
      "content2": "Il Cliente comprende che il nuovo periodo di rinnovo di {0} si applica non appena il Cliente fa clic su “Accetto” di seguito e che il nuovo periodo di rinnovo avrà inizio il giorno successivo alla fine dell’attuale periodo di rinnovo mensile del Cliente. Questo nuovo periodo di rinnovo si applicherà a tutti i moduli d’ordine attualmente in vigore con Zoom e tutti i futuri periodi di rinnovo ai sensi di tali moduli d’ordine avranno la stessa durata.",
      "content3": "Il Cliente riconosce che l’unica modifica riguarda il periodo di rinnovo e che tutti gli altri termini e condizioni di ciascun modulo d’ordine attualmente in vigore con Zoom restano invariati e pienamente efficaci in conformità ai rispettivi termini.",
      "content4": "Accetti inoltre che si tratta di un impegno contrattuale tra il Cliente e Zoom.",
      "agreementText": "Facendo clic su “Accetto”, certifichi di essere autorizzato a effettuare questa modifica per conto del Cliente e che il Cliente accetta i termini e le condizioni indicati sopra.",
      "IDecline": "Rifiuto",
      "IAccept": "Accetto"
    },
    "unableToChangeTerm": {
      "title": "Impossibile modificare il periodo di rinnovo",
      "content": "Il tuo account non è idoneo all’aggiornamento del periodo di rinnovo. <a target=\"_blank\" href=\"{0}\">Contattaci</a> se si tratta di un errore.",
      "acceptedTitle": "Periodo di rinnovo prorogato",
      "acceptedContent": "Hai già accettato i termini di rinnovo. Non è necessaria alcuna ulteriore azione.",
      "GotIt": "Ok"
    },
    "termLengthUpdated": "La durata del periodo di rinnovo è stata aggiornata a {0} mesi.",
    "termLengthUnchanged": "Durata del periodo invariata.",
    "errorInfo": "Si è verificato un errore del server. Riprova.",
    "x12MonthTerm": "periodo di dodici (12) mesi",
    "x24MonthTerm": "periodo di ventiquattro (24) mesi",
    "x12MonthTermPlural": "dodici (12) mesi",
    "x24MonthTermPlural": "ventiquattro (24) mesi"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "L’account è programmato per l’aggiornamento alla <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">nuova esperienza web di Zoom</a> il {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Controlla quando aggiornare</a>"
    },
    "completed": {
      "content": "La nuova esperienza web di Zoom è ora attiva per tutti gli utenti dell’account. Gli utenti vedranno l’interfaccia aggiornata al prossimo accesso."
    }
  }
}
